import type { IGrid } from "./types";
import type { Particle } from "./Particle";

/**
 * 行为基类
 * 所有具体的行为逻辑（如下落、移动、扩散等）都应继承此类
 */
export abstract class Behavior {
    /**
     * 如果为 true，当粒子被胶水固定(isGlued)时，此行为将被抑制
     */
    suppressByGlue: boolean = false;

    /**
     * 更新粒子状态
     * @param particle 当前粒子实例
     * @param grid 网格实例
     * @param index 粒子当前在网格中的索引
     * @returns 如果粒子移动了，返回新索引；如果被销毁，返回 -1；否则返回 undefined
     */
    abstract update(particle: Particle, grid: IGrid, index: number): number | void;
}
